<template>
  <v-dialog
      v-model="dialog"
      width="500">

    <v-card>
      <v-card-title
          primary-title>
        {{ dialogTitle }}
      </v-card-title>

      <v-card-text style="padding-top: 20px;">
        {{ deleteText }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" depressed large outlined>Odustani</v-btn>
        <v-btn @click="deleteItem()" color="error" depressed large>{{ deleteButton }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

import {serverBus} from "../../main";
import ApiV2 from "@/services/ApiV2";

export default {

  created: function () {
    serverBus.$on('show-delete-item-dialog', (table, item, deleteText = null, deleteButton = null, dialogTitle = 'Jeste li sigurni?') => {
      this.item = item;
      this.table = table;

      this.deleteText = deleteText ? deleteText : this.defaultDeleteText;
      this.deleteButton = deleteButton ? deleteButton : this.defaultDeleteButton;

      this.dialogTitle = dialogTitle;

      this.dialog = true;
    });

    serverBus.$on('close-delete-item-dialog', () => {
      this.dialog = false;
    })
  },

  methods: {
    deleteItem() {
      if (this.table === 'korisnik' || this.table === 'ucenik' || this.table === 'djelatnik') {
        ApiV2.delete('users/' + this.item.id)
            .finally(() => {
              //Reload page samo ako je opci pregled npr(TableView), inace ce router reloadat podatke
              var routeTableArrayLength = this.$getTable().split("/").length >= 2
              if (!routeTableArrayLength) {
                serverBus.$emit('reload-all-data');
              }
              serverBus.$emit('show-snackbar', true, 'Odabrana stavka je izbrisana.');

              this.dialog = false;

              //Ako je singleItem, izbiris item i vrati se korak u nazad na pregled
              if (routeTableArrayLength) {
                this.$router.go(-1)
              }
            }).catch(function () {
          serverBus.$emit('show-snackbar', false, 'Ne mogu izbrisati ovu stavku.');
        });
      } else {
        this.$axios.post(this.optimizeRouteTable() + '/izbrisi/' + this.item.id).finally(() => {
          //Reload page samo ako je opci pregled npr(TableView), inace ce router reloadat podatke
          var routeTableArrayLength = this.$getTable().split("/").length >= 2
          if (!routeTableArrayLength) {
            serverBus.$emit('reload-all-data');
          }
          serverBus.$emit('show-snackbar', true, 'Odabrana stavka je izbrisana.');

          this.dialog = false;

          //Ako je singleItem, izbiris item i vrati se korak u nazad na pregled
          if (routeTableArrayLength) {
            this.$router.go(-1)
          }
        }).catch(function () {
          serverBus.$emit('show-snackbar', false, 'Ne mogu izbrisati ovu stavku.');
        });
      }
    },
    //OptimizeRouteTable izvlaci pravilnu rutu kada brišemo SingleItem, ako je obični TableView onda je dovoljan samo this.$getTable()
    optimizeRouteTable() {
      var route_table = this.$getTable().split("/").length >= 2 ? this.$getTable().split("/") : [this.$getTable(), '']
      return route_table[0]
    },

  },

  data: function () {
    return {
      item: null,
      dialog: false,
      deleteText: '',
      deleteButton: '',
      dialogTitle: '',
      defaultDeleteText: 'Operacija koju ste zatražali može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?',
      defaultDeleteButton: 'Izbriši',
    }
  },

}
</script>
